export const voloteaConfiguration = {
  volotea_configurations: `Volotea configurations`,
};
